import { UPDATE_USER_SUCCESS,REQUEST_ALL_USERS_SUCCESS, REQUEST_ALL_USERS_FAILURE, CREATE_USER_SUCCESS, CREATE_USER_FAILURE, DELETE_USER_SUCCESS, GET_OPTED_USER_BRANDS, GET_OPTED_USER_BRANDS_FAILURE  } from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], optedUserBrands: [], errors: null };

export default function userManager(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_ALL_USERS_SUCCESS:
     
      return { ...state, ids: action.payload.data, errors: null };
      
    case REQUEST_ALL_USERS_FAILURE:
      return { ...state, ids: [], errors: null };
    case CREATE_USER_SUCCESS:
      return { ...state, ids: [...state.ids, action.payload.data[0]], errors: null };
    case CREATE_USER_FAILURE:
      return { ...state, errors: action.payload.response && action.payload.response.data.errors };
    case DELETE_USER_SUCCESS:
      return { ...state, ids: action.payload.data, errors: null };
    case UPDATE_USER_SUCCESS:
      return { ...state, ids: action.payload.data, errors: null };
      case GET_OPTED_USER_BRANDS: 
      return { ...state, optedUserBrands: action.payload, errors: null };
    case GET_OPTED_USER_BRANDS_FAILURE:
      return { ...state, optedUserBrands: [], errors: null };
      default:
      return state;
  }
}
